import React, { FC } from 'react';
import { Core } from '@everfi/reactifi';

interface ButtonProps {
  path: string;
}

export const BackButton: FC<ButtonProps> = ({ path }) => {
  return (
    <Core.Layout py="lg" px="sm" bg="surface-page" w="full">
      <Core.Layout maxW="container.lg">
        <Core.Link href={path}>
          <Core.Icon iconName="fa-arrow-left" /> Back
        </Core.Link>
      </Core.Layout>
    </Core.Layout>
  );
};
